export interface ComponentState<T> {
  uid: number | null | undefined;
  type: string;
  parent: number | null | undefined;
  props: T;
}

export function createComponentState<T>(
  uid: number | null,
  type: string,
  parent: number | null | undefined,
  props: T
): ComponentState<T> {
  return {
    uid,
    type,
    parent,
    props
  };
}
